export default "__VITE_ASSET__zDxG_FTP__"